<template>
  <p class="mb-1 text-secondary"><i class="fas fa-box mr-1"></i>{{ orders.length }} orders.</p>

  <DataTable :value="orders" stripedRows :paginator="true" :rows="10"
             paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport" 
             :rowClass="() => { return 'table-row' }" class="p-datatable-sm"
             @row-click="orderRowClicked" breakpoint="992px"
             sortField="date" :sortOrder="-1">
    <Column class="width-fourth" field="id" header="Order #">
      <template #body="slotProps">
        #{{ slotProps.data.id }}
        <PaymentMethodDisplay :item="slotProps.data.payment.payment_method" />
      </template>
    </Column>
    <Column field="status_desc" header="Status" :sortable="true"></Column>
    <Column field="customer_name" header="Customer" :sortable="true"></Column>
    <Column field="total" header="Total" :sortable="true">
      <template #body="slotProps">
        {{ formatDollars(slotProps.data.total) }}
      </template>
    </Column>
    <Column field="date" header="Date" :sortable="true">
      <template #body="slotProps">
        {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
      </template>
    </Column>
    <Column class="button-container" :exportable="false">
      <template #body="slotProps">
        <jet-button class="btn-sm" :goesTo="route('mtd.order.view', slotProps.data.id)" tabindex="-1" icon="fas fa-angle-right">View</jet-button>
      </template>
    </Column>
  </DataTable>
</template>

<script>
import moment from 'moment'
import PaymentMethodDisplay from '@/Components/Transaction/PaymentMethodDisplay'

export default {
  props: {
    orders: Array,
  },
  data() {
    return [];
  },
  components: {
    PaymentMethodDisplay,
  },
  created() {
    this.moment = moment;
  },
  methods: {
    orderRowClicked(event) {
      this.$inertia.visit(route('mtd.order.view', event.data.id))
    }
  }
}
</script>
